import React, { useState, useEffect } from 'react';
import { Clock, Plus, Edit, Trash2, MessageSquare, Link as LinkIcon } from 'lucide-react';
import api from '../api';

function ActivityFeed({ roadmapId }) {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadActivities();
  }, [roadmapId]);

  const loadActivities = async () => {
    try {
      const data = await api.getActivityLog(roadmapId);
      setActivities(data);
    } catch (error) {
      console.error('Failed to load activities:', error);
    } finally {
      setLoading(false);
    }
  };

  const getActionIcon = (action) => {
    switch (action) {
      case 'created': return <Plus className="h-4 w-4" />;
      case 'updated': return <Edit className="h-4 w-4" />;
      case 'deleted': return <Trash2 className="h-4 w-4" />;
      case 'commented': return <MessageSquare className="h-4 w-4" />;
      default: return <Clock className="h-4 w-4" />;
    }
  };

  const getActionColor = (action) => {
    switch (action) {
      case 'created': return 'text-green-600';
      case 'updated': return 'text-blue-600';
      case 'deleted': return 'text-red-600';
      case 'commented': return 'text-purple-600';
      default: return 'text-gray-600';
    }
  };

  if (loading) return <div className="animate-pulse space-y-2">{[1,2,3].map(i => <div key={i} className="h-16 bg-muted rounded" />)}</div>;

  return (
    <div className="space-y-3" data-testid="activity-feed">
      {activities.length === 0 ? (
        <div className="text-center py-8 text-muted-foreground">
          <Clock className="h-12 w-12 mx-auto mb-2 opacity-50" />
          <p>No activity yet</p>
        </div>
      ) : (
        activities.map((activity) => (
          <div key={activity._id} className="flex gap-3 p-3 bg-card border border-border rounded-lg hover:shadow-sm transition-shadow">
            <div className={`mt-1 ${getActionColor(activity.action)}`}>
              {getActionIcon(activity.action)}
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-start justify-between gap-2">
                <p className="text-sm">
                  <span className="font-semibold">{activity.user_email.split('@')[0]}</span>
                  {' '}<span className="text-muted-foreground">{activity.action}</span>{' '}
                  <span className="font-medium">{activity.entity_type}</span>
                  {activity.changes?.title && (
                    <span className="text-muted-foreground"> "{activity.changes.title}"</span>
                  )}
                </p>
                <span className="text-xs text-muted-foreground whitespace-nowrap">
                  {new Date(activity.created_at).toLocaleTimeString()}
                </span>
              </div>
              {Object.keys(activity.changes || {}).length > 1 && (
                <div className="mt-1 text-xs text-muted-foreground">
                  {Object.entries(activity.changes).filter(([k]) => k !== 'title').map(([key, value]) => (
                    <span key={key} className="mr-2">{key}: {JSON.stringify(value)}</span>
                  ))}
                </div>
              )}
            </div>
          </div>
        ))
      )}
    </div>
  );
}

export default ActivityFeed;
